var Settings = function() {
    this.defaultBlock = 'latest';
    this.defaultAccount = undefined;
};

module.exports = Settings;

